var map = {
	"./bmw_sauber.jpg": 115,
	"./brawn.jpg": 116,
	"./caterham.jpg": 117,
	"./ferrari.jpg": 118,
	"./force_india.jpg": 119,
	"./haas.jpg": 120,
	"./hrt.jpg": 121,
	"./lotus_f1.jpg": 122,
	"./lotus_racing.jpg": 123,
	"./manor.jpg": 124,
	"./marussia.jpg": 125,
	"./mclaren.jpg": 126,
	"./mercedes.jpg": 127,
	"./red_bull.jpg": 128,
	"./renault.jpg": 129,
	"./sauber.jpg": 130,
	"./toro_rosso.jpg": 131,
	"./toyota.jpg": 132,
	"./virgin.jpg": 133,
	"./williams.jpg": 134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;